import React from 'react';
import { Link } from 'react-router-dom';
import { Book, Users, UserCheck, Layers, Globe, GroupIcon } from 'lucide-react';
import { ContenedorPageTemplate } from '../../components/templates/ContenedorPageTemplate';

const HomeButton = ({ to, icon: Icon, label }) => (
  <Link to={to} className="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md hover:bg-blue-50 transition-colors">
    <Icon size={48} className="text-blue-600 mb-2" />
    <span className="text-lg font-semibold text-gray-800">{label}</span>
  </Link>
);

const InicioAdm = () => {
  return (
    <ContenedorPageTemplate fondo={false}>
      <h1 className="text-3xl font-bold text-center text-blue-800 mb-8">Bienvenido a la Plataforma Educativa <span>Edu</span><span className='text-theme-yellow'>Server</span></h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        <HomeButton to="/estudiantes" icon={Users} label="Estudiantes" />
        <HomeButton to="/docentes" icon={UserCheck} label="Docentes" />
        <HomeButton to="/programas" icon={Layers} label="Programas" />
        <HomeButton to="/idiomas" icon={Globe} label="Idiomas" />
        <HomeButton to="/grupos" icon={Users} label="Grupos" />
        <HomeButton to="/recursos" icon={Book} label="Recursos Educativos" />
      </div>

      <footer className="mt-12 text-center text-gray-600">
        <p>&copy; 2024 EduServer. Todos los derechos reservados.</p>
      </footer>
    </ContenedorPageTemplate>
  );
};

export default InicioAdm;